import * as React from "react";
const SvgFiRrBoot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-boot_svg__a)">
      <path
        fill="#062147"
        d="M19.046 11.388S15.074 10.225 15 10.181V5.816A3 3 0 0 0 17 3c0-1.654-1.346-3-3-3H3C1.346 0 0 1.346 0 3c0 1.302.839 2.402 2 2.816V23a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-5.5c0-2.969-2.113-5.546-4.954-6.112M3 2h11a1.001 1.001 0 0 1 0 2H3a1.001 1.001 0 0 1 0-2m1 18V6h9v4.028h-3a1 1 0 1 0 0 2h3.864l4.719 1.305A4.26 4.26 0 0 1 22 17.5V20z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-boot_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBoot;
